<article style="overflow: hidden; height: 100vh;">
  <div class="header">
    <h1 class="main-title">Business Development</h1>
  </div>
  <div style="overflow-y: auto; height: calc(100vh - 69px);">
    <bd-events></bd-events>
  </div>
</article>
